export interface ValuesEncoded {
    "[": "%5b"
    "]": "%5d"
    "&": "%26"
}

export const valuesEncoded: ValuesEncoded = {
    "[": "%5b",
    "]": "%5d",
    "&": "%26",
}

export const getEncodedValues = (text: string, regex: RegExp, replacementObject: ValuesEncoded) => {
    return text?.replace(regex, matched => replacementObject[matched] as string)
}
